<template>
  <div class="roomie-checkbox">
    <label
      class="roomie-checkbox__label"
      :for="id"
      :tabindex="tabIndex">
      <input
        :id="id"
        ref="input"
        v-model="checked"
        class="roomie-checkbox__input"
        type="checkbox"
        :disabled="isDisabled"
        :checked="checked"
        :data-lh-id="trakingLhId"
        @click="onChange">
      <span
        v-if="label"
        class="roomie-checkbox__text">
        {{ label }}
      </span>
      <slot />
      <span class="roomie-checkbox__checkmark" />
    </label>
  </div>
</template>

<script>

export default {
  name: 'RoomieCheckbox',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    isInitiallyChecked: {
      type: Boolean,
      default: false,
      required: false
    },
    isChecked: {
      type: Boolean,
      required: false,
      default: false
    },
    trakingLhId: {
      type: String,
      required: false,
      default: 'roomie-checkbox'
    },
    modelValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['get-value', 'update:modelValue'],
  data: function () {
    return {
      checked: this.isInitiallyChecked || this.isChecked || this.modelValue
    }
  },
  watch: {
    modelValue (newValue) {
      this.checked = newValue
    }
  },
  mounted() {
    if(this.checked) {
      this.$emit('get-value', this.id, this.$refs.input.checked)
    }
  },
  methods: {
    onChange(el) {
      this.checked = !this.checked
      this.$emit('get-value', this.id, el.srcElement.checked)
      this.$emit('update:modelValue', el.srcElement.checked)
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
